module.exports = __webpack_public_path__ + "static/media/elizondo_harinadetrigo.e6e85710.png";